export default () => ({
    activeIndex: 0,

    init() {
        this.calculateHeight()

        this.$watch('activeIndex', (activeIndex) => {
            const children = this.getChildren()

            children.forEach((child, index) => {
                if (index !== activeIndex) {
                    const video = child.querySelector('video')

                    if (video && !video.autoplay) {
                        video.pause()
                    }
                }
            })

            this.calculateHeight()
        })

        window.addEventListener('resize', this.onResize.bind(this))
    },

    getChildren() {
        return [...this.$refs.track.children]
    },

    calculateHeight() {
        const children = this.getChildren()

        children.forEach((child, index) => {
            const isActiveChild = index === this.activeIndex

            child.style.height = isActiveChild ? 'auto' : '0'
        })
    },

    goTo(index) {
        const children = this.getChildren()
        const margin = Math.max(window.innerHeight * 0.2, 96)

        this.$nextTick(() => {
            window.scrollTo({
                top: this.$root.offsetTop - margin,
                behavior: 'smooth',
            })
        })

        this.$refs.track.scrollTo({
            left: children[index]?.offsetLeft,
            behavior: 'smooth',
        })
    },

    goToDelta(delta) {
        const length = this.getChildren()?.length
        const targetIndex = this.activeIndex + delta
        const index = ((targetIndex % length) + length) % length

        this.goTo(index)
    },

    onScrollEnd() {
        const trackWidth = this.$refs.track.offsetWidth

        this.activeIndex = Math.round(this.$refs.track.scrollLeft / trackWidth)
    },

    onResize() {
        this.calculateHeight()
    },
})
